import React, { useEffect, useState } from "react";
import { navLinks } from "../mock";
import { ArrowRight, ArrowUpRight, Menu, X } from "lucide-react";

const Logo = ({ dark }) => (
  <a href="/" className="flex items-center gap-2 leading-none select-none">
    <span className={`font-serifDisplay text-[26px] tracking-tight ${dark ? "text-[#26241F]" : "text-white"}`}>
      <span className="text-[#B08D57]">L</span>oyaris
    </span>
    <span className="flex flex-col leading-none">
      <span className={`text-[9px] tracking-[0.22em] uppercase ${dark ? "text-[#8a8578]" : "text-white/70"}`}>Gestion locative</span>
      <span className={`text-[9px] tracking-[0.22em] uppercase ${dark ? "text-[#B08D57]" : "text-[#d9be8e]"}`}>Tarifs imbattables</span>
    </span>
  </a>
);

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open || window.location.pathname !== "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? "bg-[#F4F0E9]/95 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.06)]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1320px] px-5 lg:px-8">
        <div className="flex items-center justify-between h-[76px]">
          <Logo dark={solid} />

          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className={`text-[14px] font-medium transition-colors ${
                  solid ? "text-[#3a382f] hover:text-[#B08D57]" : "text-white/90 hover:text-white"
                }`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-5">
            <a
              href="/estimation-loyer"
              className={`group flex items-center gap-2 text-[14px] font-medium transition-colors ${
                solid ? "text-[#3a382f] hover:text-[#B08D57]" : "text-white hover:text-white/80"
              }`}
            >
              <span className={`flex h-7 w-7 items-center justify-center rounded-full border ${solid ? "border-[#c9c1b2]" : "border-white/40"}`}>
                <ArrowUpRight className="h-3.5 w-3.5" />
              </span>
              Estimer mon loyer
            </a>
            <a
              href="/#contact"
              className="group flex items-center gap-2 rounded-md bg-[#26241F] px-5 py-3 text-[14px] font-semibold text-white transition-all hover:bg-[#B08D57]"
            >
              Confier mon bien
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </a>
          </div>

          <button
            className={`lg:hidden ${solid ? "text-[#26241F]" : "text-white"}`}
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#F4F0E9] border-t border-[#e4ddce] px-5 py-4">
          <nav className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2.5 text-[15px] font-medium text-[#3a382f] border-b border-[#e4ddce]"
              >
                {l.label}
              </a>
            ))}
            <a href="/#contact" onClick={() => setOpen(false)} className="mt-4 flex items-center justify-center gap-2 rounded-md bg-[#26241F] px-5 py-3 text-[15px] font-semibold text-white">
              Confier mon bien <ArrowRight className="h-4 w-4" />
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
